<script>
    export let icon = 'far fa-trash'
    export let tooltip = null
    export let type = 'primary'
    export let classes = ''
    export let tabindex = 0
    export let active = false
</script>

<style>
    .SidebarButton {
        width: 50px;
        height: 50px;
        font-size: 18px;
        clear: both;
        color: #fff;

        background-color: transparent;
        border-width: 0px;
        border-style: solid;
        border-color: transparent;

        -webkit-animation-duration: .3s;
        animation-duration: .3s;

        position: relative;
        display: -webkit-inline-box;
        display: -ms-inline-flexbox;
        display: inline-block;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        overflow: visible;
        padding: calc(0.675rem - 3px) 12px;
        padding-right: 0.8125rem;
        text-align: center;
        
        
        line-height: 1.125rem;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
        vertical-align: top;
        -ms-flex-negative: 0;
        flex-shrink: 0;
        min-height: 3rem;
        border-radius: 0;
        /* text-align: left; */
        text-decoration: none;
        outline: none;
        margin: 0;
    }
    .SidebarButton .bx--assistive-text {
        right: -0.8125rem;
        top: 50%;
        -webkit-transform: translate(100%, -50%);
        transform: translate(100%, -50%);

        -webkit-box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.1);
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.1);
        /* width: -webkit-max-content;
        width: -moz-max-content;
        width: max-content; */
        max-width: 13rem;
        height: auto;
        padding: 0.1875rem 1rem;
        border-radius: 0.125rem;
        font-weight: 400;
        color: #ffffff;
        font-weight: 400;
        text-align: left;
        pointer-events: none;
        background-color: #393939;
        font-size: 0.875rem;
        font-weight: 400;
        line-height: 1.125rem;
        letter-spacing: 0.16px;

        position: absolute;
        z-index: 10000;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        opacity: 0;
        pointer-events: none;
    }
    .SidebarButton:before {
        position: absolute;
        z-index: 10000;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        width: 0;
        height: 0;
        border-style: solid;
        content: '';
        opacity: 0;
        pointer-events: none;
        top: 50%;
        right: -0.5rem;
        border-width: 0.25rem 0.38rem 0.25rem 0;
        border-color: transparent #393939 transparent transparent;
        -webkit-transform: translate(100%, -50%);
        transform: translate(100%, -50%);
    }
    .SidebarButton:hover:before, 
    .SidebarButton:hover .bx--assistive-text {
        opacity: 1;
        /* -webkit-animation: tooltip-fade 70ms cubic-bezier(0.2, 0, 0.38, 0.9);
        animation: tooltip-fade 70ms cubic-bezier(0.2, 0, 0.38, 0.9); */
    }
    .SidebarButton:hover,
    .SidebarButton:active {
        background-color: var(--forge-sidebar-hover);
    }
    .SidebarButton:focus, 
    .SidebarButton.bx--btn--icon-only.bx--tooltip__trigger:focus {
        border-color: transparent;
        outline-color: transparent;
    }
    .SidebarButton.active {
        background-color: var(--forge-sidebar-primary-selected);
    }
    .SidebarButton:focus:before, 
    .SidebarButton:focus .bx--assistive-text {
        display: none;
    }
</style>

<button class="SidebarButton {classes} bx--btn bx--btn--field bx--btn--{type} {active ? 'active' : ''} bx--btn--icon-only {tooltip ? 'bx--tooltip__trigger bx--tooltip--a11y bx--tooltip--right bx--tooltip--align-center' : ''}" 
    on:click 
    tabindex="{tabindex}">
    <i class="icon {icon}"></i>
    {#if tooltip}
        <div class="bx--assistive-text">{tooltip}</div>
    {/if}
</button>